
export interface IAbstractPeriodicTask {
  //-----------------------------------------------------------------------------------------------
  // Forcefully run the updater
  forceRefresh(): Promise<this>;
  start(): this;
  stop(): this;
  setInterval(seconds: number): this;
}

export abstract class AbstractPeriodicTask {
  private timer: number | null = null;
  private intervalSeconds: number;

  //-----------------------------------------------------------------------------------------------
  constructor(intervalSeconds: number = 300) {
    this.intervalSeconds = intervalSeconds;

    // Start periodic execution
    this.start();
  }

  //-----------------------------------------------------------------------------------------------
  // Forcefully run the updater
  public async forceRefresh(): Promise<this> {
    await this.run().catch(err => console.error('Error in periodic task:', err));
    return this;
  }

  //-----------------------------------------------------------------------------------------------
  // Abstract method to implement actual task
  protected abstract run(): Promise<void>;

  //-----------------------------------------------------------------------------------------------
  // Start periodic execution
  public start() : this {
    if (this.timer !== null) {
      clearInterval(this.timer);
    }

    this.timer = window.setInterval(async () => {
      try {
        await this.run();
      } catch (err) {
        console.error('Error in periodic task:', err);
      }
    }, this.intervalSeconds * 1000);
    return this;
  }

  //-----------------------------------------------------------------------------------------------
  // Stop periodic execution
  public stop() : this {
    if (this.timer !== null) {
      clearInterval(this.timer);
      this.timer = null;
    }
    return this;
  }

  //-----------------------------------------------------------------------------------------------
  // Update interval dynamically
  public setInterval(seconds: number) : this {
    this.intervalSeconds = seconds;
    this.start();
    return this;
  }
}
//-----------------------------------------------------------------------------------------------
// EOF
